import React from 'react'
import Button from './Button'

/* doc
---
title: PrimaryButton
name: PrimaryButton
category: React - Bulma
parent: Button
---

A `PrimaryButton` is a styled version of the `Button` component and should
be used to indicate the most important action on the page. There should be at
very most one `PrimaryButton` on any given page. The primary action button
shouldn't use outline/inverted styles either.

See `Button` component for full details.

```html_example
  <PrimaryButton href="/somewhere">
    Important Action
  </PrimaryButton>
```
*/
function PrimaryButton(props) {
  const { children, className, ...rest } = props

  const classes = [
    'is-warning',
    className || '',
  ]

  return (
    <Button {...rest} className={classes.join(' ')}>
      {children}
    </Button>
  )
}

export default PrimaryButton
